module.exports = __webpack_public_path__ + "img/sb07.706272ad.png";